import { render, staticRenderFns } from "./payment-page.vue?vue&type=template&id=3f4481d0&scoped=true"
import script from "./payment-page.vue?vue&type=script&lang=js"
export * from "./payment-page.vue?vue&type=script&lang=js"
import style0 from "./payment-page.vue?vue&type=style&index=0&id=3f4481d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4481d0",
  null
  
)

export default component.exports